var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnuncios(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 254.02 200.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.23,194.21A116.19,116.19,0,0,1,54,134.5L4.5,135A165.46,165.46,0,0,0,28,200.5H72A4,4,0,0,0,75.23,194.21Zm-24-6.71H34.8a155.79,155.79,0,0,1-8-18,167.26,167.26,0,0,1-8.8-35H40.4a120,120,0,0,0,8.8,38.8c1.4,3.35,2.88,6.42,4.38,9.23C54.73,184.69,53.39,187.5,51.23,187.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M234,72.5v45a22.65,22.65,0,0,0,0-45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.5,0a156,156,0,0,1-55,39,172.73,172.73,0,0,1-25,8,247.12,247.12,0,0,1-55.79,7.5H0v81H68A232,232,0,0,1,215.5,188l12.5.5V.5ZM63,117.5H18v-45H63Zm143.75,38c-12.45-8.66-29.9-14.93-52.19-23a225.46,225.46,0,0,0-64.81-13V70.79a167.76,167.76,0,0,0,27.4-.89c41.29-4.73,72-19.85,89.6-33.4Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnuncios);
export default __webpack_public_path__ + "static/media/Anuncios.5eee198b4d7a743ac8410893dcda8002.svg";
export { ForwardRef as ReactComponent };